let id = 0;

// Temporary function because we don't return activities in the api after performing an action
export default () => `temp-${id++}`;
